import { observable } from "mobx";
import { Type } from "class-transformer";

export class BlacklistedEmailAddressChangeAction {
  isAllowed!: boolean;
  rejectionReason?: string;
}

export class BlacklistedEmailAddressDetailAccessAction {
  isAllowed!: boolean;
}

export class BlacklistedEmailAddressPermittedActions {
  @Type(() => BlacklistedEmailAddressDetailAccessAction)
  blacklistedEmailAddressDetailAccess!: BlacklistedEmailAddressDetailAccessAction;

  @Type(() => BlacklistedEmailAddressChangeAction)
  blacklistedEmailAddressChange!: BlacklistedEmailAddressChangeAction;
}

export default class BlacklistedEmailAddress {
  id!: string;

  @observable
  emailAddressSearchPattern!: string;

  @observable
  description?: string;

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  @Type(() => Date)
  updatedAt!: Date;

  @observable
  updatedBy!: string;

  @observable
  @Type(() => Date)
  createdAt?: Date;

  @observable
  createdBy?: string;

  @Type(() => BlacklistedEmailAddressPermittedActions)
  permittedActions?: BlacklistedEmailAddressPermittedActions;
}
